import { Brand } from '@blade/std-lib'

export const SupportTicketIdTypeId = 'tradebot-tma/SupportTicketId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SupportTicketIdTypeId = typeof SupportTicketIdTypeId

export type SupportTicketId = Brand.Branded<string, SupportTicketIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupportTicketId = Brand.nominal<SupportTicketId>()
